import './ForgotPassword.scss';
import Component from './ForgotPassword.js';
export default Component;
